import React from 'react';
import { translate } from '../../utils/wp.js';
import { ModalDialog } from './ModalDialog.js';

export function OutOfStockDialog({visible, onClick}) {
    return (
        <ModalDialog
            visible={visible}
            primaryActionText={'Ok'}
            primaryAction={onClick}
            secondaryAction={onClick}
            header={translate('no_more_tickets_title')}
            body={translate('no_more_tickets_body')}
            hideCloseButton={true}
            isDismissable={true}
        />
    );
}
